import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.grey100};
  border: 1px solid ${({ theme }) => theme.colors.grey007};
  border-radius: 4px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grey600};
`;

export const AddIcon = styled.span`
  margin-inline-end: 8px;
  &::after {
    content: ${'"\\e910"'};
    font-family: 'icomoon' !important;
    font-size: 12px;
  }
`;

export const MinusIcon = styled.span`
  margin-inline-end: 8px;
  &::after {
    content: ${'"\\e90e"'};
    font-family: 'icomoon' !important;
    font-size: 12px;
  }
`;
